import PropTypes from 'prop-types';

export const PersonShape = PropTypes.shape({
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  age: PropTypes.number.isRequired,
  profession: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired,
  videoURL: PropTypes.string.isRequired,
  thumbURL: PropTypes.string.isRequired,
});

export const testimoniesContentShape = PropTypes.shape({
  backgroundColor: PropTypes.string,
  carouselColor: PropTypes.string,
  testimonies: PropTypes.arrayOf(PersonShape),
  testimonyConfig: PropTypes.shape({
    wrapperColor: PropTypes.string,
    quoteColor: PropTypes.string,
  }),
  title: PropTypes.string,
});
